import { getValueByPath } from './helpers.js';
import { f as VueComponentMixin, B as BaseComponentMixin, c as config } from './plugins-4daf8ef8.js';
import { s as script$1 } from './Icon-4445210d.js';
import { resolveComponent, openBlock, createBlock, resolveDynamicComponent, mergeProps, toHandlers, withCtx, createVNode, createCommentVNode, toDisplayString, renderSlot } from 'vue';

/**
 * The classic button, in different colors, sizes, and states
 * @displayName Button
 * @example ./examples/Button.md
 * @style _button.scss
 */

var script = {
  name: 'OButton',
  components: {
    [script$1.name]: script$1
  },
  mixins: [VueComponentMixin(), BaseComponentMixin],
  inheritAttrs: false,
  props: {
    /**
    * Color of the control, optional
    * @values primary, info, success, warning, danger, and any other custom color
    */
    variant: [String, Object],

    /**
     * Size of button, optional
     * @values small, medium, large
     */
    size: String,

    /**
     * Button label, optional when default slot
     */
    label: String,

    /**
     * Icon pack to use
     * @values mdi, fa, fas and any other custom icon pack
     */
    iconPack: String,

    /**
     * Icon name to show on the left
     */
    iconLeft: String,

    /**
     * Icon name to show on the right
     */
    iconRight: String,

    /**
     * Rounded style
     */
    rounded: {
      type: Boolean,
      default: () => {
        return getValueByPath(config, 'button.rounded', false);
      }
    },

    /**
     * Outlined style
     */
    outlined: Boolean,

    /**
     * Button will be expanded (full-width)	
     */
    expanded: Boolean,
    inverted: Boolean,

    /**
     * Button type, like native
     */
    nativeType: {
      type: String,
      default: 'button',
      validator: value => {
        return ['button', 'submit', 'reset'].indexOf(value) >= 0;
      }
    },

    /**
     * Button tag name
     * @values button, a, input, router-link, nuxt-link or other nuxt alias
     */
    tag: {
      type: String,
      default: 'button'
    },

    /**
     * Button will be disabled
     */
    disabled: Boolean,

    /**  @ignore */
    iconBoth: Boolean,
    // This is used internally
    rootClass: String,
    outlinedClass: String,
    invertedClass: String,
    expandedClass: String,
    roundedClass: String,
    disabledClass: String,
    sizeClass: String,
    variantClass: String
  },
  computed: {
    rootClasses() {
      return [this.computedClass('button', 'rootClass', 'o-button'), {
        [`${this.computedClass('button', 'sizeClass', 'o-size-')}${this.size}`]: this.size
      }, {
        [`${this.computedClass('button', 'variantClass', 'o-color-')}${this.variant}`]: this.variant
      }, {
        [this.computedClass('button', 'outlinedClass', 'o-button-outlined')]: this.outlined
      }, {
        [this.computedClass('button', 'invertedClass', 'o-button-inverted')]: this.inverted
      }, {
        [this.computedClass('button', 'expandedClass', 'o-button-expanded')]: this.expanded
      }, {
        [this.computedClass('button', 'roundedClass', 'o-button-rounded')]: this.rounded
      }, {
        [this.computedClass('button', 'disabledClass', 'o-button-disabled')]: this.disabled
      }];
    },

    computedTag() {
      if (this.disabled !== undefined && this.disabled !== false) {
        return 'button';
      }

      return this.tag;
    },

    computedNativeType() {
      if (this.tag === 'a') {
        return;
      }

      return this.nativeType;
    },

    hasDefaultSlot() {
      return this.existsSlot('default');
    }

  }
};

const _hoisted_1 = { key: 1 };
const _hoisted_2 = { key: 2 };

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_o_icon = resolveComponent("o-icon");

  return (_ctx.vueReady)
    ? (openBlock(), createBlock(resolveDynamicComponent($options.computedTag), mergeProps({ key: 0 }, _ctx.$attrs, {
        type: $options.computedNativeType,
        class: $options.rootClasses
      }, toHandlers(_ctx.listeners)), {
        default: withCtx(() => [
          ($props.iconLeft)
            ? createVNode(_component_o_icon, {
                key: 0,
                pack: $props.iconPack,
                icon: $props.iconLeft,
                size: $props.size,
                both: $props.iconBoth
              }, null, 8 /* PROPS */, ["pack", "icon", "size", "both"])
            : createCommentVNode("v-if", true),
          ($props.label)
            ? (openBlock(), createBlock("span", _hoisted_1, toDisplayString($props.label), 1 /* TEXT */))
            : ($options.hasDefaultSlot)
              ? (openBlock(), createBlock("span", _hoisted_2, [
                  renderSlot(_ctx.$slots, "default")
                ]))
              : createCommentVNode("v-if", true),
          ($props.iconRight)
            ? createVNode(_component_o_icon, {
                key: 3,
                pack: $props.iconPack,
                icon: $props.iconRight,
                size: $props.size,
                both: $props.iconBoth
              }, null, 8 /* PROPS */, ["pack", "icon", "size", "both"])
            : createCommentVNode("v-if", true)
        ]),
        _: 1
      }, 16 /* FULL_PROPS */, ["type", "class"]))
    : createCommentVNode("v-if", true)
}

script.render = render;
script.__file = "oruga/src/components/button/Button.vue";

export { script as s };
